<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157"
            text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                                    {{ threeItem.title }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                                {{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
            <!-- <template v-for="item in menus">
                <template v-if="item.childList">
                    <el-submenu :index="item.resource.resourcePath" :key="item.resource.id">
                        <template slot="title">
                            <i :class="item.resource.resourceIcon"></i><span slot="title">{{ item.resource.resourceName}}</span>
                        </template>
                        <template v-for="subItem in item.childList">
                            <el-submenu v-if="subItem.childList" :index="subItem.resource.resourcePath" :key="subItem.resource.id">
                                <template slot="title">{{ subItem.resource.resourceName }}</template>
                                <el-menu-item v-for="(threeItem,i) in subItem.childList" :key="i" :index="threeItem.resource.resourcePath">
                                    {{ threeItem.resource.resourceName }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.resource.resourcePath" :key="subItem.resource.id">
                                {{ subItem.resource.resourceName }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.resource.resourcePath" :key="item.resource.id">
                        <i :class="item.resource.resourceIcon"></i><span slot="title">{{ item.resource.resourceName }}</span>
                    </el-menu-item>
                </template>
            </template> -->
        </el-menu>
    </div>
</template>

<script>
    import bus from '../common/bus';
    export default {
        data() {
            return {
                collapse: false,
                menus: [],
                resourcesList:[],
                // items: [
                //     {
                //         icon: 'el-icon-lx-home',
                //         index: '/admin-old/dashboard',
                //         title: '系统首页'
                //     },
                //     {
                //         icon: 'el-icon-lx-cascades',
                //         index: '/admin-old/table',
                //         title: '基础表格'
                //     },
                //     {
                //         icon: 'el-icon-lx-copy',
                //         index: '/admin-old/tabs',
                //         title: 'tab选项卡'
                //     },
                //     {
                //         icon: 'el-icon-lx-calendar',
                //         index: '3',
                //         title: '表单相关',
                //         subs: [
                //             {
                //                 index: '/admin-old/form',
                //                 title: '基本表单'
                //             },
                //             {
                //                 index: '3-2',
                //                 title: '三级菜单',
                //                 subs: [
                //                     {
                //                         index: '/admin-old/editor',
                //                         title: '富文本编辑器'
                //                     },
                //                     {
                //                         index: '/admin-old/markdown',
                //                         title: 'markdown编辑器'
                //                     },
                //                 ]
                //             },
                //             {
                //                 index: '/admin-old/upload',
                //                 title: '文件上传'
                //             }
                //         ]
                //     },
                //     {
                //         icon: 'el-icon-lx-emoji',
                //         index: '/admin-old/icon',
                //         title: '自定义图标'
                //     },
                //     {
                //         icon: 'el-icon-lx-favor',
                //         index: '/admin-old/charts',
                //         title: 'schart图表'
                //     },
                //     {
                //         icon: 'el-icon-rank',
                //         index: '6',
                //         title: '拖拽组件',
                //         subs: [
                //             {
                //                 index: '/admin-old/drag',
                //                 title: '拖拽列表',
                //             },
                //             {
                //                 index: '/admin-old/dialog',
                //                 title: '拖拽弹框',
                //             }
                //         ]
                //     },
                //     {
                //         icon: 'el-icon-lx-warn',
                //         index: '7',
                //         title: '错误处理',
                //         subs: [
                //             {
                //                 index: '/admin-old/permission',
                //                 title: '权限测试'
                //             },
                //             {
                //                 index: '/admin-old/404',
                //                 title: '404页面'
                //             }
                //         ]
                //     }
                // ],
                items: [
                    {
                        icon: 'el-icon-lx-cascades',
                        index: '/admin/userTable',
                        title: '用户列表'
                    },
                    {
                        icon: 'el-icon-lx-cascades',
                        index: '/admin/roleTable',
                        title: '角色列表'
                    },
                    {
                        icon: 'el-icon-lx-cascades',
                        index: '/admin/permissionTable',
                        title: '权限列表'
                    },
                    {
                        icon: 'el-icon-lx-cascades',
                        index: '/admin/resourceTable',
                        title: '资源列表'
                    },
                    {
                        icon: 'el-icon-lx-cascades',
                        index: '/admin/sessionTable',
                        title: '会话列表'
                    },
                    {
                        icon: 'el-icon-lx-cascades',
                        index: '/admin/logTable',
                        title: '日志列表'
                    },
                ]
            }
        },
        computed:{
            onRoutes(){
                return this.$route.path.replace('/','');
            }
        },
        created(){
            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on('collapse', msg => {
                this.collapse = msg;
            });
            // this.getMenus();
        },
        methods:{
            // getResourcesList(){
            //     this.$axios({
            //         method:'get',
            //         url: '/api/user/get',
            //         withCredentials:true,
            //         params: {}
            //     }).then((response) =>{          //这里使用了ES6的语法
            //         this.resourcesList = [];
            //         var rolesArr = response.data.data.roles;
            //         for(let i=0;i<rolesArr.length;i++){
            //             var resourcesArr = rolesArr[i].resources;
            //             for(let j=0;j<resourcesArr.length;j++){
            //                 var tAdnResource = resourcesArr[j].tAdnResource;
            //                 this.resourcesList.push({
            //                     id: tAdnResource.id
            //                 })
            //             }
            //         }
            //     }).catch((error) =>{
            //         console.log(error)       //请求失败返回的数据
            //     })
            // },
            // getMenus(){
            //     this.$axios({
            //         method:'get',
            //         url: '/api/resource/getResources',
            //         withCredentials:true,
            //         params: {}
            //     }).then((response) =>{          //这里使用了ES6的语法
            //         this.menus = response.data.data;
            //         console.log(this.menus);
            //     }).catch((error) =>{
            //         console.log(error)       //请求失败返回的数据
            //     })
            // }
        }
    }
</script>

<style scoped>
    .sidebar{
        display: block;
        position: absolute;
        left: 0;
        top: 70px;
        bottom:0;
        overflow-y: scroll;
    }
    .sidebar::-webkit-scrollbar{
        width: 0;
    }
    .sidebar-el-menu:not(.el-menu--collapse){
        width: 250px;
    }
    .sidebar > ul {
        height:100%;
    }
</style>
